import { defineMessages } from 'react-intl'

export default defineMessages({
  scope: {
    id: 'containers.ProjectPage.components.ProjectProgress.step.scope',
    defaultMessage: 'Scope your project',
  },
  scopeCurrent: {
    id: 'containers.ProjectPage.components.ProjectProgress.step.scope.current',
    defaultMessage: 'Selecting voices',
  },
  lead: {
    id: 'containers.ProjectPage.components.ProjectProgress.step.lead',
    defaultMessage: 'Submit contact details',
  },
  leadCurrent: {
    id: 'containers.ProjectPage.components.ProjectProgress.step.lead.current',
    defaultMessage: 'Submit contact details',
  },
  quote: {
    id: 'containers.ProjectPage.components.ProjectProgress.step.quote',
    defaultMessage: 'Get a quote',
  },
  quoteCurrent: {
    id: 'containers.ProjectPage.components.ProjectProgress.step.quote.current',
    defaultMessage: 'We are preparing a quote for you',
  },
  acceptedQuote: {
    id: 'containers.ProjectPage.components.ProjectProgress.step.acceptedQuote',
    defaultMessage: 'Approve quote',
  },
  acceptedQuoteCurrent: {
    id: 'containers.ProjectPage.components.ProjectProgress.step.acceptedQuote.current',
    defaultMessage: 'Review and approve',
  },
  recording: {
    id: 'containers.ProjectPage.components.ProjectProgress.step.recording',
    defaultMessage: 'Recording',
  },
  recordingCurrent: {
    id: 'containers.ProjectPage.components.ProjectProgress.step.recording.current',
    defaultMessage: 'Project in progress',
  },
  production: {
    id: 'containers.ProjectPage.components.ProjectProgress.step.production',
    defaultMessage: 'Production',
  },
  productionCurrent: {
    id: 'containers.ProjectPage.components.ProjectProgress.step.production.current',
    defaultMessage: 'We are adding final touches to your recordings',
  },
  qa: {
    id: 'containers.ProjectPage.components.ProjectProgress.step.qa',
    defaultMessage: 'Q/A',
  },
  qaCurrent: {
    id: 'containers.ProjectPage.components.ProjectProgress.step.qa.current',
    defaultMessage: 'Your project manager is quality checking your production',
  },
  delivery: {
    id: 'containers.ProjectPage.components.ProjectProgress.step.delivery',
    defaultMessage: 'Delivery',
  },
  deliveryCurrent: {
    id: 'containers.ProjectPage.components.ProjectProgress.step.delivery.current',
    defaultMessage: 'Your recordings are ready',
  },
})
